import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ae49a60e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = {
  key: 0,
  class: "col"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
    /*#__PURE__*/_createElementVNode("h2", { class: "billing-info" }, "Payment Information")
  ])
], -1))
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
    /*#__PURE__*/_createElementVNode("h2", { class: "billing-info" }, "Billing Address")
  ])
], -1))
const _hoisted_10 = {
  key: 0,
  class: "row"
}
const _hoisted_11 = { class: "col" }
const _hoisted_12 = {
  key: 1,
  class: "row"
}
const _hoisted_13 = { class: "col" }
const _hoisted_14 = {
  key: 2,
  class: "row"
}
const _hoisted_15 = { class: "col" }
const _hoisted_16 = {
  key: 3,
  class: "row"
}
const _hoisted_17 = { class: "col" }
const _hoisted_18 = {
  key: 4,
  class: "row"
}
const _hoisted_19 = { class: "col" }
const _hoisted_20 = {
  key: 5,
  class: "row"
}
const _hoisted_21 = { class: "col" }
const _hoisted_22 = {
  key: 1,
  class: "col"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "sub-button-like-link" }, "Add credit card", -1))
const _hoisted_24 = [
  _hoisted_23
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.user.billingInfo?.paymentMethod)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, "Ends with " + _toDisplayString(_ctx.user.billingInfo.paymentMethod.lastFour), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, " Expires on " + _toDisplayString(_ctx.user.billingInfo.paymentMethod.expMonth) + "/" + _toDisplayString(_ctx.user.billingInfo.paymentMethod.expYear), 1)
          ]),
          (_ctx.user.billingInfo?.address)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                (_ctx.user.billingInfo.address.country)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.mapCountry.get(_ctx.user.billingInfo.address.country)), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.user.billingInfo.address.street1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.user.billingInfo.address.street1), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.user.billingInfo.address.street2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.user.billingInfo.address.street2), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.user.billingInfo.address.city)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.user.billingInfo.address.city), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.user.billingInfo.address.region)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.user.billingInfo.address.region), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.user.billingInfo.address.postalCode)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.user.billingInfo.address.postalCode), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("a", {
            class: "sub-button-like-link",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggleBillingInfoChangeBlock')))
          }, "Change payment information")
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_24))
  ]))
}